__turbopack_context__.v({
  "body": "Toast-module-scss-module__KK7IdW__body",
  "border": "Toast-module-scss-module__KK7IdW__border",
  "close": "Toast-module-scss-module__KK7IdW__close",
  "closeIcon": "Toast-module-scss-module__KK7IdW__closeIcon",
  "content": "Toast-module-scss-module__KK7IdW__content",
  "default": "Toast-module-scss-module__KK7IdW__default",
  "error": "Toast-module-scss-module__KK7IdW__error",
  "icon": "Toast-module-scss-module__KK7IdW__icon",
  "info": "Toast-module-scss-module__KK7IdW__info",
  "root": "Toast-module-scss-module__KK7IdW__root",
  "statusIcon": "Toast-module-scss-module__KK7IdW__statusIcon",
  "success": "Toast-module-scss-module__KK7IdW__success",
  "warning": "Toast-module-scss-module__KK7IdW__warning",
});
